import { useT } from "./i18n";

/** The next page of a list, asked for by the member (PLAN.md 4.20). */
export function ShowMore({ hasMore, busy = false, onMore }: { hasMore: boolean; busy?: boolean; onMore: () => void }) {
  const t = useT();
  if (!hasMore) return null;
  return <p className="show-more"><button type="button" disabled={busy} onClick={onMore}>{busy ? t.common.loading : t.browse.showMore}</button></p>;
}
